import dayjs from "dayjs"

export function getFormatNoticeV2(data, isFormat = true, formatStr = "MM/DD/YYYY") {
  if (!data) return data
  const formatValue = (v) => {
    if (!v) return ""
    return isFormat ? dayjs(v).format(formatStr) : dayjs(v, formatStr)
  }

  if (data.dateDenied) data.dateDenied = formatValue(data.dateDenied)
  if (data.actionDate) data.actionDate = formatValue(data.actionDate)
  if (data.counterOfferExpires) data.counterOfferExpires = formatValue(data.counterOfferExpires)
  if (data.deliveryDate) data.deliveryDate = formatValue(data.deliveryDate)

  if (data.disclosureOfUseOfInformation) {
    data.disclosureOfUseOfInformation = data.disclosureOfUseOfInformation.map((item) => ({
      ...item,
      dateIssued: formatValue(item?.dateIssued),
    }))
  }
  return data
}

export function participantDisplayName(participant = {}) {
  return [participant.firstName, participant.middleName, participant.lastName, participant.suffix]
    .filter(Boolean)
    .join(" ")
}
